// FB
window.fbAsyncInit = function () {
  FB.init({
    appId: '1540922579536139',
    xfbml: true,
    version: 'v2.6'
  });
};
